import { Avatar, Divider, Stack, Typography } from "@datanomik/commons-ui";
import { ReactNode } from "react";

type RuleCreationPageLayoutProps = {
  header: string;
  subheader: string;
  icon: ReactNode;
  children: ReactNode;
};

export const RuleCreationPageLayout = (props: RuleCreationPageLayoutProps) => {
  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={2}>
        {props.icon && <Avatar>{props.icon}</Avatar>}
        <Stack>
          <Typography fontSize="16px" fontWeight="500">
            {props.header}
          </Typography>
          <Typography color="text.secondary">{props.subheader}</Typography>
        </Stack>
      </Stack>
      <Divider
        sx={{
          my: "24px",
        }}
      />
      {props.children}
    </Stack>
  );
};
